namespace Matrix.Data {
    export class SourceColumns {
        static columnsKey = 'Data.Source';
    }
}
